import { create } from '@thoughtspot/logger';
import { mapSDKAxisActionsToHostActions, updateCustomActionOnClickCallback, validateOpenAxisMenuEventPayloadObject, } from './util';
const logger = create('axis-menu-events');
const validateOpenAxisMenuEventPayload = (eventData, columns) => {
    const payload = eventData.payload;
    try {
        validateOpenAxisMenuEventPayloadObject(payload, columns);
    }
    catch (err) {
        logger.warn(err);
        return {
            isValid: false,
            errors: [err.toString()],
        };
    }
    return {
        isValid: true,
    };
};
const getOpenAxisMenuEventProcessor = (props) => {
    const { chartModel, openAxisMenu, iFrameWindow, emitEvent } = props;
    const chartColumns = chartModel.columns.map(col => col.column);
    return {
        validateEventPayload: (eventData) => {
            return validateOpenAxisMenuEventPayload(eventData, chartColumns);
        },
        executeEvent: (eventData) => {
            const payload = eventData.payload;
            const { event: inputEvent, columnIds, selectedActions: selectedSDKActions, customActions, } = payload;
            const selectedActions = mapSDKAxisActionsToHostActions(selectedSDKActions);
            const { x: xPos, y: yPos, } = iFrameWindow.current.getBoundingClientRect();
            const eventObj = {
                ...inputEvent,
                clientX: inputEvent.clientX + xPos,
                clientY: inputEvent.clientY + yPos,
            };
            const convertedCustomActions = updateCustomActionOnClickCallback(customActions, emitEvent, columnIds, inputEvent);
            openAxisMenu(eventObj, columnIds, selectedActions, convertedCustomActions);
            return Promise.resolve();
        },
    };
};
const getCloseAxisMenuEventProcessor = (props) => {
    const { closeAxisMenu } = props;
    return {
        validateEventPayload: (eventData) => {
            return {
                isValid: true,
            };
        },
        executeEvent: (eventData) => {
            closeAxisMenu();
            return Promise.resolve();
        },
    };
};
const testHooks = {
    validateOpenAxisMenuEventPayload,
};
export { getOpenAxisMenuEventProcessor, getCloseAxisMenuEventProcessor, testHooks, };
//# sourceMappingURL=index.js.map